import {
  ComProtocol,
  ComProtocolConnectOptions,
  ComProtocolOptions,
  ComProtocolSendOptions,
  ConnectionState,
  ConnectionStateChangeEvent,
} from '@iotize/tap/protocol/api';
import { Observable, Subject } from 'rxjs';

import { debug } from './debug';

const TAG = 'ComProtocol';

export abstract class AbstractComProtocol implements ComProtocol {
  _connectionStateChange?: Subject<ConnectionStateChangeEvent>;
  protected connectionState: ConnectionState;

  protected _options: ComProtocolOptions;

  get options() {
    return this._options;
  }

  set options(options: ComProtocolOptions) {
    this._options = options;
  }

  abstract write(data: Uint8Array): Promise<any>;

  abstract read(): Promise<Uint8Array>;

  abstract connect(options?: ComProtocolConnectOptions): Observable<any>;

  abstract disconnect(options?: ComProtocolConnectOptions): Observable<any>;

  abstract send(
    data: Uint8Array,
    options?: ComProtocolSendOptions,
  ): Observable<Uint8Array>;

  constructor() {
    this.connectionState = ConnectionState.DISCONNECTED;
    this._options = {
      connect: {
        timeout: 1000,
      },
      disconnect: {
        timeout: 1000,
      },
      send: {
        timeout: 500,
      },
    };
  }

  getConnectionState(): ConnectionState {
    return this.connectionState;
  }

  isConnected(): boolean {
    return this.connectionState == ConnectionState.CONNECTED;
  }

  setConnectionState(connectionState: ConnectionState) {
    debug(
      TAG,
      'setConnectionState',
      ConnectionState[connectionState],
      'Old: ',
      ConnectionState[this.connectionState],
    );
    let event = {
      newState: connectionState,
      oldState: this.connectionState,
    };
    this.connectionState = connectionState;
    if (this._connectionStateChange) {
      this._connectionStateChange.next(event);
    }
    return this;
  }

  /**
   * Must be implemented in childs
   */
  receiveStream(): Observable<Uint8Array> {
    throw new Error('Method not implemented.');
  }

  onConnectionStateChange(): Observable<ConnectionStateChangeEvent> {
    if (!this._connectionStateChange) {
      this._connectionStateChange = new Subject<ConnectionStateChangeEvent>();
    }
    return this._connectionStateChange;
  }
}
